/* eslint-disable no-restricted-properties */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-plusplus */
/* eslint-disable default-case */
/* eslint-disable no-else-return */
type PresenceCategory = "AVL" | "BSY" | "DND" | "INV";
export interface SyncPresenceConfig {
    rcId: string,
    rcAccessToken: string,
    idToken: string,
    organizationId: string,
    apiUrl: string,
    otherApiUrl: string
}

interface RetryConfig {
    maxRetries: number;
    baseDelayMs: number;
    maxDelayMs: number;
  }
  
  interface SyncResult {
    success: boolean;
    rcSuccess: boolean;
    saSuccess: boolean;
    error?: string;
    rollbackPerformed?: boolean;
  }
  
  const DEFAULT_RETRY_CONFIG: RetryConfig = {
    maxRetries: 3,
    baseDelayMs: 1000,
    maxDelayMs: 5000
  };

  interface CapturedUserState {
    // Original presence fields
    lastPresenceStatus: string;
    status: string;
    display: string;
    lastDndStatus: string;
    custom: string;
    lastMessage: string;
    
    // Derived state information for rollback
    isRegularStatus: boolean;
    isAdHocCustom: boolean;
    isStandardCustom: boolean;
    derivedCategory: PresenceCategory;
    customText?: string; // For ad hoc custom statuses
    standardCustomStatus?: string; // For standard custom statuses
    
    // Timestamp for tracking
    capturedAt: string;
  }
/*
There are 8 types of presence status changes we need to account for:
Regular and "Custom" status changes for each of the four categories.

Each time we change status we need to do two things, notify Ring Central
and notify the Shadow Agent backend. 

This file contains four major helper functions to do this,
- tellRcRegular
- tellRcCustom
- tellSaRegular
- tellSaCustom
which are then composed into two exported functions:
- syncPresenceRegular
- syncPresenceCustom

*/

/**
 * 
 * 
 * @param otherApiUrl 
 * @param rcId 
 * @param rcAccessToken 
 * @param idToken 
 * @param category 
 * @param user 
 * @returns 
 */
async function tellRcRegular(
    otherApiUrl: string,
    rcId: string,
    rcAccessToken: string,
    idToken: string,
    category: PresenceCategory,
    user: any,
    dndOverride?: string | undefined
  ): Promise<Response> {
    // 1. Decide default “suffix” for each category:
    const defaultSuffix: Record<PresenceCategory, string> = {
      AVL: "Available",
      BSY: "Busy",
      DND: "Do not disturb",
      INV: "Invisible",
    };
    const suffix = defaultSuffix[category];
  
    // 2. Compute message = "<CAT>:<suffix>"
    const message = `${category}:${suffix}`;
  
    // 3. Decide userStatus/dndStatus based on category and user.lastDndStatus
    let userStatus: string | undefined;
    let dndStatus: string | undefined;
  
    switch (category) {
      case "AVL":
        userStatus = "Available";
        dndStatus =
          (user.lastDndStatus === "DoNotAcceptAnyCalls" || (user.lastDndStatus === "DoNotAcceptDepartmentCalls" && user.lastPresenceStatus === "Offline" && user.invisibleCallControl) )
            ? "TakeAllCalls"
            : undefined;
        break;
  
      case "BSY":
        userStatus = "Busy";
        dndStatus =
          user.lastDndStatus === "DoNotAcceptAnyCalls"
            ? "TakeAllCalls"
            : undefined;
        break;
  
      case "DND":
        // “Do Not Disturb” → always force DND
        userStatus = undefined;
        dndStatus = "DoNotAcceptAnyCalls";
        break;
  
      case "INV":
        userStatus = "Offline";
        // “Invisible” → preserve whatever lastDndStatus was
        dndStatus = user.lastDndStatus;
        break;
    }
    // If dndOverride is provided, use it instead of the computed dndStatus
    if (dndOverride) {
        dndStatus = dndOverride;
    }
  
    // 4. Build the payload, omitting undefined fields
    const payload: Record<string, any> = {
      message,
      id: rcId,
      token: rcAccessToken,
    };
    if (userStatus) {
      payload.userStatus = userStatus;
    }
    if (dndStatus) {
      payload.dndStatus = dndStatus;
    }
  
    // 5. Fire the fetch
    return fetch(`${otherApiUrl}/flash`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: idToken || "",
      },
      body: JSON.stringify(payload),
    });
  }


  /**
 * Sends a “custom” presence update to RingCentral.
 *
 * @param otherApiUrl        – base URL (e.g. process.env.REACT_APP_API_URL)
 * @param rcId               – the RC extension ID
 * @param rcAccessToken      – the RingCentral access token
 * @param idToken            – your bearer token for authorization header
 * @param category           – one of "AVL", "BSY", "DND", "INV"
 * @param customStatusText   – the actual custom‐text to appear after “<CAT>:”
 * @param user               – the current RC user object (for lastDndStatus)
 */
async function tellRcCustom(
    otherApiUrl: string,
    rcId: string,
    rcAccessToken: string,
    idToken: string,
    category: PresenceCategory,
    user: any,
    table: any,
    customStatus: string,
    /*
    customStatusText: string,
    user: any,*/
    dndOverride?: string | undefined
  ): Promise<Response> {
    // 1. message = "<CAT>:<customStatusText>"
    console.log("tellRcCustom table: ", table);
    const message = `${category}:${ table.status === "[custom]" ? customStatus: table.status}`;
  
    // 2. Decide userStatus / dndStatus exactly as in tellRcRegular
    let userStatus: string | undefined;
    let dndStatus: string | undefined;
  
    switch (category) {
      case "AVL":
        userStatus = "Available";
        dndStatus =
          (user.lastDndStatus === "DoNotAcceptAnyCalls" || (user.lastDndStatus === "DoNotAcceptDepartmentCalls" && user.lastPresenceStatus === "Offline" && user.invisibleCallControl) )
            ? "TakeAllCalls"
            : undefined;
        break;
  
      case "BSY":
        userStatus = "Busy";
        dndStatus =
          user.lastDndStatus === "DoNotAcceptAnyCalls"
            ? "TakeAllCalls"
            : undefined;
        break;
  
      case "DND":
        userStatus = undefined;
        dndStatus = "DoNotAcceptAnyCalls";
        break;
  
      case "INV":
        userStatus = "Offline";
        dndStatus = user.lastDndStatus;
        break;
    }
    // If dndOverride is provided, use it instead of the computed dndStatus
    if (dndOverride) {
      dndStatus = dndOverride;
    }
  
    // 3. Build payload, omitting undefined fields
    const payload: Record<string, any> = {
      message,
      id: rcId,
      token: rcAccessToken,
    };
    if (userStatus) {
      payload.userStatus = userStatus;
    }
    if (dndStatus) {
      payload.dndStatus = dndStatus;
    }
    console.log("tellRcCustom payload: ", payload);
    // 4. Fire the fetch
    return fetch(`${otherApiUrl}/flash`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: idToken || "",
      },
      body: JSON.stringify(payload),
    });
  }

  /**
 * Sends a “regular” (non-custom) presence update to the SA backend.
 *
 * @param apiUrl           – the SA endpoint
 * @param organizationId   – RC account ID
 * @param rcId             – RC extension ID
 * @param category         – one of "AVL", "BSY", "DND", "INV"
 * @param user             – the current RC user (for lastDndStatus)
 */
async function tellSaRegularPresence(
    apiUrl: string,
    organizationId: string,
    rcId: string,
    category: PresenceCategory,
    user: any,
    duration?: any,
    dndOverride?: string | undefined
  ): Promise<Response> {
    console.log("This is Duration: ", duration);
  
    // 1. Decide default suffix for each category:
    const defaultSuffix: Record<PresenceCategory, string> = {
      AVL: "Available",
      BSY: "Busy",
      DND: "Do not disturb",
      INV: "Invisible",
    };
    const suffix = defaultSuffix[category];
  
    // 2. Build message = "<CAT>:<suffix>"
    const message = `${category}:${suffix}`;
  
    // 3. Decide presenceStatus/dndStatus:
    let presenceStatus: "Available" | "Busy" | "Offline";
    let dndStatus: string | undefined;
  
    switch (category) {
      case "AVL":
        presenceStatus = "Available";
        dndStatus =
          (user.lastDndStatus === "DoNotAcceptAnyCalls" || (user.lastDndStatus === "DoNotAcceptDepartmentCalls" && user.lastPresenceStatus === "Offline" && user.invisibleCallControl) )
            ? "TakeAllCalls"
            : undefined;
        break;
  
      case "BSY":
        presenceStatus = "Busy";
        dndStatus =
          user.lastDndStatus === "DoNotAcceptAnyCalls"
            ? "TakeAllCalls"
            : undefined;
        break;
  
      case "DND":
        presenceStatus = "Busy";
        dndStatus = "DoNotAcceptAnyCalls";
        break;
  
      case "INV":
        presenceStatus = "Offline";
        dndStatus = user.lastDndStatus;
        break;
    }
    // If dndOverride is provided, use it instead of the computed dndStatus
    if (dndOverride) {
      dndStatus = dndOverride;
    }
    // 4. Build the body object
    const bodyObj: Record<string, any> = {
      dndStatus,
      presenceStatus,
      message,
    };
    if (duration && duration !== 0) {
        bodyObj.duration = duration;
        console.log("Firing custom presence update to SA with body: ", bodyObj.duration);
      }else{
          console.log("No Duration provided");
      }
  
    // 5. Fire the fetch
    return fetch(apiUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        event: `/restapi/v1.0/account/${organizationId}/extension/${rcId}/presence`,
        body: bodyObj,
        send: true,
      }),
    });
  }
  

  /**
 * Sends a “custom” presence update to the SA backend.
 *
 * @param apiUrl           – the SA endpoint
 * @param organizationId   – RC account ID
 * @param rcId             – RC extension ID
 * @param category         – one of "AVL", "BSY", "DND", "INV"
 * @param customStatusText – the actual custom‐text (e.g. customAvailable, customBusy, etc.)
 * @param user             – the current RC user (for lastDndStatus)
 */
async function tellSaCustomPresence(
    apiUrl: string,
    organizationId: string,
    rcId: string,
    rcAccessToken: string,
    category: PresenceCategory,
    user: any,
    table: any,
    customStatus: string,
    dndOverride?: string | undefined
  ): Promise<Response> {
    console.log("This is Duration: ", table.duration);
    console.log("TellSA table: ", table);
  
    // 1. message = "<CAT>:[custom]"
    const message = `${category}:${table.status}`;
  
    // 2. Build the “custom” field: "CAT:<customStatusText>"
    const customField = table.status === "[custom]" ? `${category}:${customStatus}` : undefined ;
  
    // 3. Decide presenceStatus / dndStatus exactly as in tellSaRegularPresence
    let presenceStatus: "Available" | "Busy" | "Offline";
    let dndStatus: string | undefined;
  
    switch (category) {
      case "AVL":
        presenceStatus = "Available";
        dndStatus =
          (user.lastDndStatus === "DoNotAcceptAnyCalls" || (user.lastDndStatus === "DoNotAcceptDepartmentCalls" && user.lastPresenceStatus === "Offline" && user.invisibleCallControl) )
            ? "TakeAllCalls"
            : undefined;
        break;
  
      case "BSY":
        presenceStatus = "Busy";
        dndStatus =
          user.lastDndStatus === "DoNotAcceptAnyCalls"
            ? "TakeAllCalls"
            : undefined;
        break;
  
      case "DND":
        presenceStatus = "Busy";
        dndStatus = "DoNotAcceptAnyCalls";
        break;
  
      case "INV":
        presenceStatus = "Offline";
        dndStatus = user.lastDndStatus;
        break;
    }
    // If dndOverride is provided, use it instead of the computed dndStatus
    if (dndOverride) {
      dndStatus = dndOverride;
    }

  
    // 4. Build the body object, including the “custom” field
    const bodyObj: Record<string, any> = {
      dndStatus,
      presenceStatus,
      message,
      custom: customField,
      token: rcAccessToken,
    };

    if (table.duration && table.duration !== 0) {
      //bodyObj.duration = Number(table.duration);
      bodyObj.timer = {
        duration: Number(table.duration),
        autoSwitchback: table.autoSwitchback ?? true
      };
      
      console.log("Firing custom presence update to SA with body: ", bodyObj);
    }else{
        console.log("No Duration provided");
    }
  
    // 5. Fire the fetch
    
    console.log("Firing custom presence update to SA with body: ", bodyObj.duration);
    return fetch(apiUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        event: `/restapi/v1.0/account/${organizationId}/extension/${rcId}/presence`,
        body: bodyObj,
        send: true,
      }),
    });
  }



/**
 * Enhanced presence sync with concurrent execution and retry/rollback logic
 */
export async function syncPresenceRegular(
  config: SyncPresenceConfig,
  category: PresenceCategory,
  currentUser: any,
  duration?: number,
  dndOverride?: string | undefined,
  retryConfig: RetryConfig = DEFAULT_RETRY_CONFIG
): Promise<SyncResult> {
  console.log("syncPresenceRegular called with: ", config);

  // Capture original state before any changes
  const originalState = captureUserState(currentUser);
  console.log("Captured original state:", originalState);

  try {
    // Execute both calls concurrently with retry logic
    const [rcResult, saResult] = await Promise.allSettled([
      executeWithRetry(() => tellRcRegular(
        config.otherApiUrl,
        config.rcId,
        config.rcAccessToken,
        config.idToken,
        category,
        currentUser,
        dndOverride
      ), retryConfig, 'RingCentral'),
      
      executeWithRetry(() => tellSaRegularPresence(
        config.apiUrl,
        config.organizationId,
        config.rcId,
        category,
        currentUser,
        duration,
        dndOverride
      ), retryConfig, 'SA')
    ]);

    const rcSuccess = rcResult.status === 'fulfilled' && rcResult.value.ok;
    const saSuccess = saResult.status === 'fulfilled' && saResult.value.ok;

    console.log(`RC Result: ${rcSuccess ? 'SUCCESS' : 'FAILED'}`);
    console.log(`SA Result: ${saSuccess ? 'SUCCESS' : 'FAILED'}`);

    // Handle different failure scenarios
    if (rcSuccess && saSuccess) {
      return { success: true, rcSuccess: true, saSuccess: true };
    }

    if (!rcSuccess && saSuccess) {
      // RC failed but SA succeeded - rollback SA
      console.warn("RC failed, rolling back SA changes");
      const rollbackResult = await performSaRollback(config, originalState, currentUser);
      return {
        success: false,
        rcSuccess: false,
        saSuccess: true,
        rollbackPerformed: rollbackResult,
        error: `RingCentral sync failed: ${rcResult.status === 'rejected' ? rcResult.reason : 'Unknown error'}`
      };
    }

    if (rcSuccess && !saSuccess) {
      // SA failed but RC succeeded - rollback RC
      console.warn("SA failed, rolling back RC changes");
      const rollbackResult = await performRcRollback(config, originalState, currentUser);
      return {
        success: false,
        rcSuccess: true,
        saSuccess: false,
        rollbackPerformed: rollbackResult,
        error: `SA sync failed: ${saResult.status === 'rejected' ? saResult.reason : 'Unknown error'}`
      };
    }

    // Both failed - no rollback needed
    return {
      success: false,
      rcSuccess: false,
      saSuccess: false,
      error: 'Both RingCentral and SA sync failed'
    };

  } catch (error) {
    console.error("Unexpected error in syncPresenceRegular:", error);
    return {
      success: false,
      rcSuccess: false,
      saSuccess: false,
      error: `Unexpected error: ${error instanceof Error ? error.message : 'Unknown error'}`
    };
  }
}

/**
 * Enhanced custom presence sync with concurrent execution and retry/rollback logic
 */
export async function syncPresenceCustom(
  config: SyncPresenceConfig,
  category: PresenceCategory,
  currentUser: any,
  table: any,
  customStatus: string,
  dndOverride?: string | undefined,
  retryConfig: RetryConfig = DEFAULT_RETRY_CONFIG
): Promise<SyncResult> {
  console.log("syncPresenceCustom called with: ", config);
  console.log("Table:", table, "CustomStatus:", customStatus);

  // Capture original state before any changes
  const originalState = captureUserState(currentUser);
  console.log("Captured original state:", originalState);

  try {
    // Execute both calls concurrently with retry logic
    const [rcResult, saResult] = await Promise.allSettled([
      executeWithRetry(() => tellRcCustom(
        config.otherApiUrl,
        config.rcId,
        config.rcAccessToken,
        config.idToken,
        category,
        currentUser,
        table,
        customStatus,
        dndOverride
      ), retryConfig, 'RingCentral'),
      
      executeWithRetry(() => tellSaCustomPresence(
        config.apiUrl,
        config.organizationId,
        config.rcId,
        config.rcAccessToken,
        category,
        currentUser,
        table,
        customStatus,
        dndOverride
      ), retryConfig, 'SA')
    ]);

    const rcSuccess = rcResult.status === 'fulfilled' && rcResult.value.ok;
    const saSuccess = saResult.status === 'fulfilled' && saResult.value.ok;

    console.log(`RC Result: ${rcSuccess ? 'SUCCESS' : 'FAILED'}`);
    console.log(`SA Result: ${saSuccess ? 'SUCCESS' : 'FAILED'}`);

    // Handle different failure scenarios
    if (rcSuccess && saSuccess) {
      return { success: true, rcSuccess: true, saSuccess: true };
    }

    if (!rcSuccess && saSuccess) {
      // RC failed but SA succeeded - rollback SA
      console.warn("RC failed, rolling back SA changes");
      const rollbackResult = await performSaRollback(config, originalState, currentUser);
      return {
        success: false,
        rcSuccess: false,
        saSuccess: true,
        rollbackPerformed: rollbackResult,
        error: `RingCentral sync failed: ${rcResult.status === 'rejected' ? rcResult.reason : 'Unknown error'}`
      };
    }

    if (rcSuccess && !saSuccess) {
      // SA failed but RC succeeded - rollback RC
      console.warn("SA failed, rolling back RC changes");
      const rollbackResult = await performRcRollback(config, originalState, currentUser);
      return {
        success: false,
        rcSuccess: true,
        saSuccess: false,
        rollbackPerformed: rollbackResult,
        error: `SA sync failed: ${saResult.status === 'rejected' ? saResult.reason : 'Unknown error'}`
      };
    }

    // Both failed - no rollback needed
    return {
      success: false,
      rcSuccess: false,
      saSuccess: false,
      error: 'Both RingCentral and SA sync failed'
    };

  } catch (error) {
    console.error("Unexpected error in syncPresenceCustom:", error);
    return {
      success: false,
      rcSuccess: false,
      saSuccess: false,
      error: `Unexpected error: ${error instanceof Error ? error.message : 'Unknown error'}`
    };
  }
}


/**
 * Execute a function with exponential backoff retry logic
 */
async function executeWithRetry<T>(
  fn: () => Promise<T>,
  retryConfig: RetryConfig,
  serviceName: string
): Promise<T> {
  let lastError: Error | undefined;
  
  for (let attempt = 0; attempt <= retryConfig.maxRetries; attempt++) {
    try {
      const result = await fn();
      if (attempt > 0) {
        console.log(`${serviceName} succeeded on attempt ${attempt + 1}`);
      }
      return result;
    } catch (error) {
      lastError = error instanceof Error ? error : new Error(String(error));
      
      if (attempt < retryConfig.maxRetries) {
        const delay = Math.min(
          retryConfig.baseDelayMs * Math.pow(2, attempt),
          retryConfig.maxDelayMs
        );
        console.warn(`${serviceName} attempt ${attempt + 1} failed, retrying in ${delay}ms:`, lastError.message);
        await new Promise(resolve => setTimeout(resolve, delay));
      }
    }
  }
  
  console.error(`${serviceName} failed after ${retryConfig.maxRetries + 1} attempts:`, lastError?.message || 'Unknown error occurred');
  throw lastError || new Error('Unknown error occurred');
}


async function performSaRollback(
  config: SyncPresenceConfig,
  originalState: CapturedUserState,
  currentUser: any
): Promise<boolean> {
  try {
    console.log("Performing SA rollback to original state:", originalState);
    
    if (originalState.isRegularStatus) {
      // Rollback to regular status
      const rollbackResp = await tellSaRegularPresence(
        config.apiUrl,
        config.organizationId,
        config.rcId,
        originalState.derivedCategory,
        currentUser,
        undefined, // No duration for rollback
        originalState.lastDndStatus
      );
      
      const success = rollbackResp.ok;
      console.log(`SA regular rollback ${success ? 'succeeded' : 'failed'}`);
      return success;
      
    } else if (originalState.isAdHocCustom) {
      // Rollback to ad hoc custom status
      const rollbackTable = {
        status: "[custom]",
        duration: 0 // Reset duration for rollback
      };
      
      const rollbackResp = await tellSaCustomPresence(
        config.apiUrl,
        config.organizationId,
        config.rcId,
        config.rcAccessToken,
        originalState.derivedCategory,
        currentUser,
        rollbackTable,
        originalState.customText || "",
        originalState.lastDndStatus
      );
      
      const success = rollbackResp.ok;
      console.log(`SA ad hoc custom rollback ${success ? 'succeeded' : 'failed'}`);
      return success;
      
    } else if (originalState.isStandardCustom) {
      // Rollback to standard custom status
      const rollbackTable = {
        status: originalState.standardCustomStatus || "",
        duration: 0 // Reset duration for rollback
      };
      
      const rollbackResp = await tellSaCustomPresence(
        config.apiUrl,
        config.organizationId,
        config.rcId,
        config.rcAccessToken,
        originalState.derivedCategory,
        currentUser,
        rollbackTable,
        "", // No custom text for standard customs
        originalState.lastDndStatus
      );
      
      const success = rollbackResp.ok;
      console.log(`SA standard custom rollback ${success ? 'succeeded' : 'failed'}`);
      return success;
    }
    
    console.error("Unable to determine original status type for rollback");
    return false;
    
  } catch (error) {
    console.error("SA rollback failed:", error);
    return false;
  }
}

/**
 * Rollback RC changes to original state
 */async function performRcRollback(
  config: SyncPresenceConfig,
  originalState: CapturedUserState,
  currentUser: any
): Promise<boolean> {
  try {
    console.log("Performing RC rollback to original state:", originalState);
    
    if (originalState.isRegularStatus) {
      // Rollback to regular status
      const rollbackResp = await tellRcRegular(
        config.otherApiUrl,
        config.rcId,
        config.rcAccessToken,
        config.idToken,
        originalState.derivedCategory,
        currentUser,
        originalState.lastDndStatus
      );
      
      const success = rollbackResp.ok;
      console.log(`RC regular rollback ${success ? 'succeeded' : 'failed'}`);
      return success;
      
    } else if (originalState.isAdHocCustom) {
      // Rollback to ad hoc custom status
      const rollbackTable = {
        status: "[custom]",
        duration: 0 // Reset duration for rollback
      };
      
      const rollbackResp = await tellRcCustom(
        config.otherApiUrl,
        config.rcId,
        config.rcAccessToken,
        config.idToken,
        originalState.derivedCategory,
        currentUser,
        rollbackTable,
        originalState.customText || "",
        originalState.lastDndStatus
      );
      
      const success = rollbackResp.ok;
      console.log(`RC ad hoc custom rollback ${success ? 'succeeded' : 'failed'}`);
      return success;
      
    } else if (originalState.isStandardCustom) {
      // Rollback to standard custom status  
      const rollbackTable = {
        status: originalState.standardCustomStatus || "",
        duration: 0 // Reset duration for rollback
      };
      
      const rollbackResp = await tellRcCustom(
        config.otherApiUrl,
        config.rcId,
        config.rcAccessToken,
        config.idToken,
        originalState.derivedCategory,
        currentUser,
        rollbackTable,
        "", // No custom text for standard customs
        originalState.lastDndStatus
      );
      
      const success = rollbackResp.ok;
      console.log(`RC standard custom rollback ${success ? 'succeeded' : 'failed'}`);
      return success;
    }
    
    console.error("Unable to determine original status type for rollback");
    return false;
    
  } catch (error) {
    console.error("RC rollback failed:", error);
    return false;
  }
}


function mapStatusToCategory(status: string): PresenceCategory {
  switch (status?.toLowerCase()) {
    case 'available':
      return 'AVL';
    case 'busy':
      return 'BSY';
    case 'offline':
      return 'INV'; 
    default:
      return 'AVL';
  }
}

function mapDisplayToCategory(display: string): PresenceCategory {
  if (display?.includes('Available')) return 'AVL';
  if (display?.includes('Busy')) return 'BSY';
  if (display?.includes('Do not disturb') || display?.includes('DND')) return 'DND';
  if (display?.includes('Invisible')) return 'INV';
  return 'AVL'; // fallback
}



function captureUserState(currentUser: any): CapturedUserState {
  const display = currentUser.display || "";
  const lastMessage = currentUser.lastMessage || "";
  const custom = currentUser.custom || "";
  
  // Check if this is a regular status (exact matches)
  const regularStatuses = [
    'AVL:Available',
    'BSY:Busy', 
    'DND:Do not disturb',
    'INV:Invisible'
  ];
  const isRegularStatus = regularStatuses.includes(display);
  
  // Check if this is an ad hoc custom (custom field populated)
  const isAdHocCustom = custom !== "";
  
  // If not regular or ad hoc, it must be standard custom
  const isStandardCustom = !isRegularStatus && !isAdHocCustom;
  
  // Extract custom text for ad hoc customs
  let customText: string | undefined;
  if (isAdHocCustom && display.includes(':')) {
    const [, text] = display.split(':');
    customText = text;
  }
  
  // Extract standard custom status
  let standardCustomStatus: string | undefined;
  if (isStandardCustom && display.includes(':')) {
    const [, status] = display.split(':');
    standardCustomStatus = status;
  }
  
  return {
    lastPresenceStatus: currentUser.lastPresenceStatus,
    status: currentUser.status,
    display: currentUser.display,
    lastDndStatus: currentUser.lastDndStatus,
    custom: currentUser.custom || "",
    lastMessage: currentUser.lastMessage,
    
    isRegularStatus,
    isAdHocCustom,
    isStandardCustom,
    derivedCategory: mapDisplayToCategory(display),
    customText,
    standardCustomStatus,
    
    capturedAt: new Date().toISOString()
  };
}